export const GET_UNIONS = "GET_UNIONS";
export const GET_UNION_BY_ID = "GET_UNION_BY_ID";
export const UPDATE_UNION = "UPDATE_UNION";
export const DELETE_UNION = "DELETE_UNION";
export const CREATE_UNION = "CREATE_UNION";
